goog.provide("shadow.js.shim.module$$mui$material$DialogContent$default");
shadow.js.shim.module$$mui$material$DialogContent$default = shadow.js.shim.module$$mui$material$DialogContent.default;
